export const USERS_ADD = 'at/entities/USERS_ADD'
export const USERS_REMOVE = 'at/entities/USERS_REMOVE'
export const USERS_SET = 'at/entities/USERS_SET'
export const USER_GROUPS_ADD = 'at/entities/USER_GROUPS_ADD'
export const USER_GROUPS_SET = 'at/entities/USER_GROUPS_SET'
export const USER_GROUPS_REMOVE = 'at/entities/USER_GROUPS_REMOVE'
export const TIME_ZONE_GROUPS_ADD = 'at/entities/TIME_ZONE_GROUPS_ADD'
export const TIME_ZONE_GROUPS_SET = 'at/entities/TIME_ZONE_GROUPS_SET'
export const TIME_ZONE_GROUPS_REMOVE = 'at/entities/TIME_ZONE_GROUPS_REMOVE'
export const TASKS_ADD = 'at/entities/TASKS_ADD'
export const TASKS_REMOVE = 'at/entities/TASKS_REMOVE'
export const TASKS_CLEAR = 'at/entities/TASKS_CLEAR'
export const PROJECTS_ADD = 'at/entities/PROJECTS_ADD'
export const PROJECTS_REMOVE = 'at/entities/PROJECTS_REMOVE'
export const CUSTOMERS_ADD = 'at/entities/CUSTOMERS_ADD'
export const CUSTOMERS_REMOVE = 'at/entities/CUSTOMERS/REMOVE'
export const WORKFLOW_STATUSES_ADD = 'at/entities/WORKFLOW_STATUSES_ADD'
export const WORKFLOW_STATUSES_SET = 'at/entities/WORKFLOW_STATUSES_SET'
export const WORKFLOW_STATUSES_REMOVE = 'at/entities/WORKFLOW_STATUSES_REMOVE'
export const TYPES_OF_WORK_SET = 'at/entities/TYPES_OF_WORK_SET'
export const LEAVE_TYPES_SET = 'at/entitiews/LEAVE_TYPES_SET'



// WEBPACK FOOTER //
// ./web/js/entities/actionTypes.js